<ng-container *ngIf="state === 'loading'">
  <a class="main content-item" *ngFor="let n of [].constructor(count)">
    <div class="thumb-container">
      <div class="thumb">
        <div class="overlay"></div>
      </div>
    </div>
    <div href="javascript:;" class="content-container">
      <header><span class="placeholder"></span></header>
      <summary><span class="placeholder"></span></summary>
      <time><span class="placeholder"></span></time>
    </div>
  </a>

  <div class="more-content" *ngIf="showFranchises">
    <a class="primary">
      <span class="placeholder"></span>
    </a>

    <ul>
      <li>
        <a><span class="placeholder"></span></a>
        <a><span class="placeholder"></span></a>
        <a><span class="placeholder"></span></a>
      </li>
    </ul>
  </div>
</ng-container>
<ng-container *ngIf="state === 'ready'">
  <a [routerLink]="articleUrlFor(article)" class="main content-item" *ngFor="let article of articles">
    <div class="thumb-container">
      <div class="thumb" [responsiveBackgroundImage]="article.lead_image">
        <div class="overlay"></div>
      </div>
    </div>
    <div href="javascript:;" class="content-container">
      <header>{{ article.feed_headline || article.title }}</header>
      <summary>{{ article.feed_summary }}</summary>
      <time>{{ article.publish_date | date: 'longDate' }}</time>
    </div>
  </a>

  <div class="more-content" *ngIf="showFranchises && franchise && moreFranchises">
    <a class="primary" routerLink="/stores/{{ franchise.slug }}">{{ franchise.name }} </a>

    <ul>
      <li *ngFor="let franchise of moreFranchises">
        <a routerLink="/stories/{{ franchise.slug ?? franchise.id }}">
          {{franchise.name}}
        </a>
      </li>
    </ul>
  </div>
</ng-container>